import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f5b9884"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "d-flex flex-column flex-wrap flex-sm-nowrap p-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_6 = {
  key: 1,
  class: "d-flex align-items-center text-gray-400 me-5 mb-2"
}
const _hoisted_7 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_10 = { class: "card mb-5 mb-xl-10" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-boldest m-0" }, "Basic Data")
  ])
], -1))
const _hoisted_12 = { class: "card-body p-9" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group d-flex flex-wrap" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label required fw-bold fs-6" }, "Salutation", -1))
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group d-flex flex-wrap" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label required fw-bold fs-6" }, "First Name", -1))
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group d-flex flex-wrap" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label required fw-bold fs-6" }, "Last Name", -1))
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group d-flex flex-wrap" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label required fw-bold fs-6" }, "Merchant Company", -1))
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group d-flex flex-wrap" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label required fw-bold fs-6" }, "Position", -1))
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-group d-flex flex-wrap" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group d-flex flex-wrap" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "form-group d-flex flex-wrap" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Decision Path", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1))
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group d-flex flex-wrap" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Report to", -1))
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "form-group d-flex flex-wrap" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Department", -1))
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "form-group d-flex flex-wrap" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Decision Level", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Additional Information", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1))
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "form-group d-flex flex-wrap" }
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = { class: "form-group d-flex flex-wrap" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "WhatsApp Account", -1))
const _hoisted_55 = { class: "col-md-6" }
const _hoisted_56 = { class: "form-group d-flex flex-wrap" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Fax", -1))
const _hoisted_58 = { class: "col-md-6" }
const _hoisted_59 = { class: "form-group d-flex flex-wrap" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Private Phone", -1))
const _hoisted_61 = { class: "col-md-6" }
const _hoisted_62 = { class: "form-group d-flex flex-wrap" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Other Phone", -1))
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "form-group d-flex flex-wrap" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Other Phone Notice", -1))
const _hoisted_67 = { class: "col-md-6" }
const _hoisted_68 = { class: "form-group d-flex flex-wrap" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Birthday", -1))
const _hoisted_70 = { class: "col-md-6" }
const _hoisted_71 = { class: "form-group d-flex flex-wrap" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Assistant", -1))
const _hoisted_73 = { class: "col-md-6" }
const _hoisted_74 = { class: "form-group d-flex flex-wrap" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Assistant Email", -1))
const _hoisted_76 = { class: "col-md-6" }
const _hoisted_77 = { class: "form-group d-flex flex-wrap" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Assistant Phone", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Quick Notes", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1))
const _hoisted_81 = { class: "form-group d-flex flex-wrap" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Overall Notes", -1))
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col-md-6" }
const _hoisted_85 = { class: "form-group d-flex flex-wrap" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Fulfillment Order Contact ?", -1))
const _hoisted_87 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_88 = /*#__PURE__*/_createTextVNode("Back to List")
const _hoisted_89 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Save Changes ", -1))
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = { class: "card mb-5 mb-xl-10" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-boldest m-0" }, "Deactivate Contacts")
  ])
], -1))
const _hoisted_94 = { class: "card-body border-top p-9" }
const _hoisted_95 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-9 p-6" }
const _hoisted_96 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, " You Are Deactivating Your Contacts "),
    /*#__PURE__*/_createElementVNode("p", { class: "fs-6 text-gray-600" }, " For extra security, this requires you to confirm ")
  ])
], -1))
const _hoisted_98 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Deactivate Contacts ", -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_101 = [
  _hoisted_99,
  _hoisted_100
]
const _hoisted_102 = { class: "card mb-5 mb-xl-10" }
const _hoisted_103 = { class: "card-header border-0" }
const _hoisted_104 = { class: "card-title m-0" }
const _hoisted_105 = { class: "fw-boldest m-0" }
const _hoisted_106 = { class: "card-body border-top p-9" }
const _hoisted_107 = { class: "row" }
const _hoisted_108 = { class: "col-md-6" }
const _hoisted_109 = { class: "form-group d-flex flex-wrap" }
const _hoisted_110 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_111 = { class: "el-form-item__content" }
const _hoisted_112 = { class: "col-md-6" }
const _hoisted_113 = { class: "form-group d-flex flex-wrap" }
const _hoisted_114 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_115 = { class: "el-form-item__content" }
const _hoisted_116 = { class: "col-md-6" }
const _hoisted_117 = { class: "form-group d-flex flex-wrap" }
const _hoisted_118 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_119 = { class: "el-form-item__content" }
const _hoisted_120 = { class: "col-md-6" }
const _hoisted_121 = { class: "form-group d-flex flex-wrap" }
const _hoisted_122 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_123 = { class: "el-form-item__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.details.lastname) + " " + _toDisplayString(_ctx.details.firstname), 1),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.details.email)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: 'mailto:' + _ctx.details.email,
                class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
              }, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com011.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.details.email), 1)
              ], 8, _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.details.address)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen018.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.details.address), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.details.website)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: _ctx.details.website,
                class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2",
                target: "_blank"
              }, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/coding/cod007.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.details.website), 1)
              ], 8, _hoisted_8))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createVNode(_component_el_form, {
        onSubmit: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
        model: _ctx.formData,
        rules: _ctx.rules,
        ref: "formRef"
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_el_form_item, { prop: "salutation" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.salutation,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.salutation) = $event)),
                        clearable: "",
                        placeholder: "Please select Salutation",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Male",
                            value: '1'
                          }),
                          _createVNode(_component_el_option, {
                            label: "Female",
                            value: '2'
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_el_form_item, { prop: "firstname" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.firstname,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.firstname) = $event)),
                        type: "text",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_el_form_item, { prop: "lastname" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.lastname,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.lastname) = $event)),
                        type: "text",
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_el_form_item, { prop: "merchant_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.merchant_id,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.merchant_id) = $event)),
                        filterable: "",
                        clearable: "",
                        remote: "",
                        "remote-method": _ctx.searchMerchantSourceItems,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant_id, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "remote-method"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(_component_el_form_item, { prop: "position" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_autocomplete, {
                        class: "w-100",
                        modelValue: _ctx.formData.position,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.position) = $event)),
                        clearable: "",
                        "fetch-suggestions": _ctx.querySearchAsync,
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "fetch-suggestions", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-form-label fw-bold fs-6", {
                  required:
                    _ctx.formData.phone == '' &&
                    _ctx.formData.mobile == '' &&
                    _ctx.formData.wechat == '',
                }])
                  }, "Email", 2),
                  _createVNode(_component_el_form_item, { prop: "email" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.email,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.email) = $event)),
                        type: "email"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-form-label fw-bold fs-6", {
                  required:
                    _ctx.formData.email == '' &&
                    _ctx.formData.mobile == '' &&
                    _ctx.formData.wechat == '',
                }])
                  }, "Phone", 2),
                  _createVNode(_component_el_form_item, { prop: "phone" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.phone,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.phone) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-form-label fw-bold fs-6", {
                  required:
                    _ctx.formData.phone == '' &&
                    _ctx.formData.email == '' &&
                    _ctx.formData.wechat == '',
                }])
                  }, "Mobile", 2),
                  _createVNode(_component_el_form_item, { prop: "mobile" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.mobile,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.mobile) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _hoisted_35,
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createVNode(_component_el_form_item, { prop: "report_to" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.report_to,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.report_to) = $event)),
                        clearable: "",
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.report_to, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createVNode(_component_el_form_item, { prop: "department" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_autocomplete, {
                        class: "w-100",
                        modelValue: _ctx.formData.department,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.department) = $event)),
                        clearable: "",
                        "fetch-suggestions": _ctx.querySearchAsyncDepartment,
                        placeholder: _ctx.$t('common.plsEnter')
                      }, null, 8, ["modelValue", "fetch-suggestions", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createVNode(_component_el_form_item, { prop: "decision_level" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.decision_level,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.decision_level) = $event)),
                        clearable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.decision_level, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _hoisted_47,
            _hoisted_48,
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["col-form-label fw-bold fs-6", {
                  required:
                    _ctx.formData.phone == '' &&
                    _ctx.formData.email == '' &&
                    _ctx.formData.mobile == '',
                }])
                  }, "WeChat Account", 2),
                  _createVNode(_component_el_form_item, { prop: "wechat" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.wechat,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.wechat) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createVNode(_component_el_form_item, { prop: "whats_app" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.whats_app,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.whats_app) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _createVNode(_component_el_form_item, { prop: "fax" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.fax,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.fax) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createVNode(_component_el_form_item, { prop: "private_phone" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.private_phone,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.private_phone) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createVNode(_component_el_form_item, { prop: "other_phone" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.other_phone,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.other_phone) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createVNode(_component_el_form_item, { prop: "other_phone_notice" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.other_phone_notice,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.other_phone_notice) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createVNode(_component_el_form_item, { prop: "birthday" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.birthday,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.birthday) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: "Pick a date",
                        style: {"width":"100%"},
                        onChange: _cache[18] || (_cache[18] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'birthday')
                  ))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _hoisted_72,
                  _createVNode(_component_el_form_item, { prop: "assistant" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.assistant,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.assistant) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _hoisted_75,
                  _createVNode(_component_el_form_item, { prop: "assistant_email" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.assistant_email,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.assistant_email) = $event)),
                        type: "email"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _hoisted_78,
                  _createVNode(_component_el_form_item, { prop: "assistant_phone" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.assistant_phone,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.assistant_phone) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _hoisted_79,
            _hoisted_80,
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _createVNode(_component_el_form_item, { prop: "overall_notes" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.overall_notes,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.overall_notes) = $event)),
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _hoisted_86,
                  _createVNode(_component_el_form_item, { prop: "is_fulfillment_order_contact" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.is_fulfillment_order_contact,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.is_fulfillment_order_contact) = $event)),
                        "active-value": 1,
                        "inactive-value": 0,
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createVNode(_component_router_link, {
              to: { name: 'contacts' },
              class: "btn btn-secondary align-self-center me-2"
            }, {
              default: _withCtx(() => [
                _hoisted_88
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_89, _hoisted_91)), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_92, [
      _hoisted_93,
      _createElementVNode("div", _hoisted_94, [
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("span", _hoisted_96, [
            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
          ]),
          _hoisted_97
        ])
      ]),
      _createElementVNode("div", _hoisted_98, [
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-danger fw-bold",
          ref: "deleteButton",
          onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.deleteContacts && _ctx.deleteContacts(...args)))
        }, _hoisted_101, 512)
      ])
    ])), [
      [_directive_auth, { auth: ['delete'] }]
    ]),
    _createElementVNode("div", _hoisted_102, [
      _createElementVNode("div", _hoisted_103, [
        _createElementVNode("div", _hoisted_104, [
          _createElementVNode("h3", _hoisted_105, _toDisplayString(_ctx.t("common.historyLog")), 1)
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_106, [
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("label", _hoisted_110, _toDisplayString(_ctx.t("common.creator")), 1),
              _createElementVNode("div", _hoisted_111, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.created_uid,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.__show.created_uid) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_112, [
            _createElementVNode("div", _hoisted_113, [
              _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.t("common.creationDate")), 1),
              _createElementVNode("div", _hoisted_115, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.created_at,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.created_at) = $event)),
                  type: "datetime",
                  placeholder: "Pick a date",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_116, [
            _createElementVNode("div", _hoisted_117, [
              _createElementVNode("label", _hoisted_118, _toDisplayString(_ctx.t("common.lastModifiedBy")), 1),
              _createElementVNode("div", _hoisted_119, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.updated_uid,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.__show.updated_uid) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_120, [
            _createElementVNode("div", _hoisted_121, [
              _createElementVNode("label", _hoisted_122, _toDisplayString(_ctx.t("common.lastModifiedDate")), 1),
              _createElementVNode("div", _hoisted_123, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.updated_at,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.updated_at) = $event)),
                  type: "datetime",
                  placeholder: "Pick a date",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ])
  ], 64))
}